export enum HomeSectionsEnum {
  Carrousel = '',
  Levels = 'niveles',
  Features = 'que-nos-diferencia',
  News = 'noticias',
  Admission = 'admision'
}